import type { ResponseType } from '@/types/common';
import httpUtil from '@/utils/http';
export * from './project';

const request = httpUtil.accurate.request;
const prefix = 'v1/issues/count';

export interface ClosedTrendItem {
  date: string;
  closedCount: number;
  count: number;
}

export type ClosedTrendDimension = 'day' | 'week' | 'month' | 'year';

export const issueStaticsApi = {
  /**
   * @description 获取基本统计信息
   */
  getBase(data: any): ResponseType {
    return request({
      url: prefix + '/base',
      method: 'POST',
      data,
    });
  },

  /**
   * @description 获取优先级统计信息
   */
  getPriority(data: any): ResponseType {
    return request({
      url: prefix + '/priority',
      method: 'POST',
      data,
    });
  },

  /**
   * @description 获取严重程度统计信息
   */
  getSeverity(data: any): ResponseType {
    return request({
      url: prefix + '/severity',
      method: 'POST',
      data,
    });
  },

  /**
   * @description 获取问题类型统计信息
   */
  getIssueType(data: any): ResponseType {
    return request({
      url: prefix + '/issueType',
      method: 'POST',
      data,
    });
  },

  /**
   * @description 获取问题状态统计信息
   */
  getStatus(data: any): ResponseType {
    return request({
      url: prefix + '/status',
      method: 'POST',
      data,
    });
  },

  /**
   * @description 获取创建趋势
   */
  getCreatedTrend(data: any): ResponseType {
    return request({
      url: prefix + '/createdTrend',
      method: 'POST',
      data,
    });
  },

  /**
   * @description 获取Bug状态趋势
   */
  getBugTrend(data: any): ResponseType {
    return request({
      url: prefix + '/bugTrend',
      method: 'POST',
      data,
    });
  },

  /**
   * @description 获取问题关闭信息
   */
  getClosedRate(data: any): ResponseType {
    return request({
      url: prefix + '/closedRate',
      method: 'POST',
      data,
    });
  },

  /**
   * @description 获取问题总信息
   */
  getTotalData(data: any): ResponseType {
    return request({
      url: prefix + '/totalData',
      method: 'POST',
      data,
    });
  },

  /**
   * @description 获取经办人问题信息
   */
  getAssigneeData(data: any): ResponseType {
    return request({
      url: prefix + '/assigneeData',
      method: 'POST',
      data,
    });
  },

  /**
   * @description 获取未关闭问题责任人信息
   */
  getUnClosedData(data: any): ResponseType {
    return request({
      url: prefix + '/unClosedData',
      method: 'POST',
      data,
    });
  },

  /**
   * @description 获取阶段问题信息
   */
  getStageData(data: any): ResponseType {
    return request({
      url: prefix + '/stageData',
      method: 'POST',
      data,
    });
  },

  /**
   * @description 获取问题严重程度信息
   */
  getSeverityData(data: any): ResponseType {
    return request({
      url: prefix + '/severityData',
      method: 'POST',
      data,
    });
  },

  /**
   * @description 获取问题总信息（按经办人所属部门分组，喂"问题来源/未关闭来源分布"饼图的部门版）
   */
  getTotalDataByDept(data: any): ResponseType {
    return request({
      url: prefix + '/totalDataByDept',
      method: 'POST',
      data,
    });
  },

  /**
   * @description 获取问题严重程度信息（按经办人所属部门分组）
   */
  getSeverityDataByDept(data: any): ResponseType {
    return request({
      url: prefix + '/severityDataByDept',
      method: 'POST',
      data,
    });
  },

  /**
   * @description 获取问题关闭趋势 (按 day/week/month/year 聚合 issue_change_items 中的关闭事件)
   */
  getClosedTrend(data: any): ResponseType<ClosedTrendItem[]> {
    return request({
      url: prefix + '/closedTrend',
      method: 'POST',
      data,
    });
  },
};
